module.exports = __webpack_public_path__ + "static/media/search.caa26bac.png";